import React, { useEffect, useState, SyntheticEvent, useCallback } from 'react'
import { Box, Container, Grid, useMediaQuery, Theme, Tabs, Tab } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useForm } from 'react-hook-form'
import { TourList } from './tour-list'
import {
  getTourAll,
  getTourAllV2,
  getTourAllV3,
  getTourAllV4,
  getTourRegion,
  getTourSubdivision,
  getTourNomination,
  getTourTU,
  getTourMM,
} from '../../../../api'
import { SelectInput, TabPanel } from '../../../../components'
import { winners } from './winners'
import { useReduxSelector } from '../../../../hooks'

export const WinnersSection: React.FC = (): JSX.Element => {
  const classes = useStyles()
  const md = useMediaQuery(({ breakpoints: { down } }: Theme) => down(960))
  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  const { data: constants } = useReduxSelector((state) => state.constants)
  const { NOW = 0 } = constants || {}

  const [tab, setTab] = useState<number>(3)

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  const [dataFilter, setDataFilter] = useState<any>({
    tu: [],
    mm: [],
    region: [],
    subdivision: [],
    nomination: [],
  })

  const [formProps, setFormProps] = useState<any>({
    data: undefined,
    processed: false,
  })

  const [formPropsV2, setFormPropsV2] = useState<any>({
    data: undefined,
    processed: false,
  })

  const [formPropsV3, setFormPropsV3] = useState<any>({
    data: undefined,
    processed: false,
  })

  const [formPropsV4, setFormPropsV4] = useState<any>({
    data: undefined,
    processed: false,
  })

  const hookForm = useForm<any>({
    defaultValues: undefined,
    mode: 'onBlur',
  })

  const hookFormV2 = useForm<any>({
    defaultValues: undefined,
    mode: 'onBlur',
  })

  const hookFormV3 = useForm<any>({
    defaultValues: undefined,
    mode: 'onBlur',
  })

  const hookFormV4 = useForm<any>({
    defaultValues: undefined,
    mode: 'onBlur',
  })

  const defaultItemSelect = '(Пусто)'

  const [initTable, setInitTable] = useState<boolean>(false)
  const [initTableV2, setInitTableV2] = useState<boolean>(false)
  const [initTableV3, setInitTableV3] = useState<boolean>(false)
  const [initTableV4, setInitTableV4] = useState<boolean>(false)
  const [tour, setTour] = useState<any>({ data: [] })
  const [tourV2, setTourV2] = useState<any>({ data: [] })
  const [tourV3, setTourV3] = useState<any>({ data: [] })
  const [tourV4, setTourV4] = useState<any>({ data: [] })
  const [perPage, setPerPage] = useState<number>(5)
  const [page, setPage] = useState<number>(1)
  const [pageV2, setPageV2] = useState<number>(1)
  const [pageV3, setPageV3] = useState<number>(1)
  const [pageV4, setPageV4] = useState<number>(1)
  const [loaded, setLoaded] = useState<boolean>(false)

  const handleChange = (event: SyntheticEvent, value: number, stage: number) => {
    getTourAll({ data: formProps.data, page: value, perPage }).then((res) => {
      setTour(res)
      setPage(value)
    })
  }

  const handleChangeV2 = (event: SyntheticEvent, value: number, stage: number) => {
    getTourAllV2({ data: formPropsV2.data, page: value, perPage }).then((res) => {
      setTourV2(res)
      setPageV2(value)
    })
  }

  const handleChangeV3 = (event: SyntheticEvent, value: number, stage: number) => {
    getTourAllV3({ data: formPropsV3.data, page: value, perPage }).then((res) => {
      setTourV3(res)
      setPageV3(value)
    })
  }

  const handleChangeV4 = (event: SyntheticEvent, value: number, stage: number) => {
    getTourAllV4({ data: formPropsV4.data, page: value, perPage }).then((res) => {
      setTourV4(res)
      setPageV4(value)
    })
  }

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue)
    if (newValue === 0) {
      hookFormV2.reset()
      hookFormV3.reset()
      hookFormV4.reset()
    } else if (newValue === 1) {
      hookForm.reset()
      hookFormV3.reset()
      hookFormV4.reset()
    } else if (newValue === 2) {
      hookForm.reset()
      hookFormV2.reset()
      hookFormV4.reset()
    } else if (newValue === 3) {
      hookForm.reset()
      hookFormV2.reset()
      hookFormV3.reset()
    }
  }

  const loadDataFilter = () => {
    let dataTU: any = []
    let dataMM: any = []
    let dataRegion: any = []
    let dataSubdivision: any = []
    let dataNomination: any = []

    Promise.all([
      getTourRegion().then((res) => {
        dataRegion = res.data.region
      }),
      getTourSubdivision().then((res) => {
        dataSubdivision = res.data.subdivision
      }),
      getTourNomination().then((res) => {
        dataNomination = res.data.nomination
      }),
      getTourTU().then((res) => {
        dataTU = res.data.tu
      }),
      getTourMM().then((res) => {
        dataMM = res.data.mm
      }),
    ]).then(() => {
      setDataFilter({
        tu: dataTU,
        mm: dataMM,
        region: dataRegion,
        subdivision: dataSubdivision,
        nomination: dataNomination,
      })
      setLoaded(true)
    })
  }

  const onSubmitForm = (data: any) => {
    const dataTour = data
    setFormProps({ ...formProps, processed: true })

    if (dataTour.region === '') dataTour.region = undefined
    if (dataTour.subdivision === '') dataTour.subdivision = undefined
    if (dataTour.nomination === '') dataTour.nomination = undefined

    getTourAll({ data: { ...dataTour }, page, perPage }).then((res) => {
      if (res.data?.length > 0 && !initTable) {
        setInitTable(true)
      }
      setTour(res)
      setFormProps({ data, processed: false })
    })
  }

  const onSubmitFormV2 = (data: any) => {
    const dataTour = data
    console.log(dataTour)
    setFormPropsV2({ ...formProps, processed: true })

    if (dataTour.tu === '' || dataTour.tu === undefined) dataTour.tu = undefined
    else {
      dataFilter.tu.every((item: any, index: number) => {
        const fullName = `${item.lastName} ${item.firstName}${item.middleName ? ` ${item.middleName}` : ''}`

        if (fullName === dataTour.tu) {
          if (dataTour.nomination === '') dataTour.nomination = undefined
          dataTour.tu = item.id
          getTourAllV2({ data: { ...dataTour }, page: pageV2, perPage }).then((res) => {
            setTourV2(res)
            setFormPropsV2({ data, processed: false })
          })
          return false
        }
        return true
      })
    }
    if (dataTour.nomination === '') dataTour.nomination = undefined

    if (dataTour.tu === undefined) {
      getTourAllV2({ data: { ...dataTour }, page: pageV2, perPage }).then((res) => {
        if (res.data?.length > 0 && !initTableV2) {
          setInitTableV2(true)
        }
        setTourV2(res)
        setFormPropsV2({ data, processed: false })
      })
    }
  }

  const onSubmitFormV3 = (data: any) => {
    const dataTour = data
    setFormPropsV3({ ...formProps, processed: true })

    if (dataTour.mm === '') dataTour.mm = undefined
    else {
      dataFilter.mm.every((item: any, index: number) => {
        const fullName = `${item.lastName} ${item.firstName}${item.middleName ? ` ${item.middleName}` : ''}`

        if (fullName === dataTour.mm) {
          if (dataTour.nomination === '') dataTour.nomination = undefined
          dataTour.mm = item.id
          getTourAllV3({ data: { ...dataTour }, page: pageV3, perPage }).then((res) => {
            setTourV3(res)
            setFormPropsV3({ data, processed: false })
          })
          return false
        }
        return true
      })
    }
    if (dataTour.nomination === '') dataTour.nomination = undefined

    if (dataTour.mm === undefined) {
      getTourAllV3({ data: { ...dataTour }, page: pageV3, perPage }).then((res) => {
        if (res.data?.length > 0 && !initTableV3) {
          setInitTableV3(true)
        }
        setTourV3(res)
        setFormPropsV3({ data, processed: false })
      })
    }
  }

  const onSubmitFormV4 = (data: any) => {
    const dataTour = data
    setFormPropsV4({ ...formProps, processed: true })

    if (dataTour.mm === '') dataTour.mm = undefined
    else {
      dataFilter.mm.every((item: any, index: number) => {
        const fullName = `${item.lastName} ${item.firstName}${item.middleName ? ` ${item.middleName}` : ''}`

        if (fullName === dataTour.mm) {
          if (dataTour.nomination === '') dataTour.nomination = undefined
          dataTour.mm = item.id
          getTourAllV4({ data: { ...dataTour }, page: pageV3, perPage }).then((res) => {
            setTourV3(res)
            setFormPropsV3({ data, processed: false })
          })
          return false
        }
        return true
      })
    }
    if (dataTour.nomination === '') dataTour.nomination = undefined

    if (dataTour.mm === undefined) {
      getTourAllV4({ data: { ...dataTour }, page: pageV4, perPage }).then((res) => {
        if (res.data?.length > 0 && !initTableV4) {
          setInitTableV4(true)
        }
        setTourV4(res)
        setFormPropsV4({ data, processed: false })
      })
    }
  }

  const autoSubmit = useCallback(() => {
    hookForm.handleSubmit(onSubmitForm)()
  }, [])

  const autoSubmitV2 = useCallback(() => {
    hookFormV2.handleSubmit(onSubmitFormV2)()
  }, [])

  const autoSubmitV3 = useCallback(() => {
    hookFormV3.handleSubmit(onSubmitFormV3)()
  }, [])

  const autoSubmitV4 = useCallback(() => {
    hookFormV4.handleSubmit(onSubmitFormV4)()
  }, [])

  useEffect(() => {
    loadDataFilter()
  }, [])

  useEffect(() => {
    if (loaded) {
      autoSubmit()
      autoSubmitV2()
      autoSubmitV3()
      autoSubmitV4()
    }
  }, [loaded])

  useEffect(() => {
    const subscription = hookForm.watch(hookForm.handleSubmit(onSubmitForm))
    return () => subscription.unsubscribe()
  }, [hookForm.handleSubmit, hookForm.watch])

  useEffect(() => {
    const subscriptionV2 = hookFormV2.watch(hookFormV2.handleSubmit(onSubmitFormV2))
    return () => subscriptionV2.unsubscribe()
  }, [hookFormV2.handleSubmit, hookFormV2.watch, dataFilter])

  useEffect(() => {
    const subscriptionV3 = hookFormV3.watch(hookFormV3.handleSubmit(onSubmitFormV3))
    return () => subscriptionV3.unsubscribe()
  }, [hookFormV3.handleSubmit, hookFormV3.watch, dataFilter])

  useEffect(() => {
    const subscriptionV4 = hookFormV4.watch(hookFormV4.handleSubmit(onSubmitFormV4))
    return () => subscriptionV4.unsubscribe()
  }, [hookFormV4.handleSubmit, hookFormV4.watch, dataFilter])

  return (
    <Box className={classes.page}>
      <Container className={classes.container}>
        <Grid container direction="row" alignItems="flex-start" justifyContent="center">
          <Grid item xs={12} md={10} lg={9}>
            <Box className={classes.title}>Турнирная таблица</Box>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          {tourV2?.total > 0 && (
            <Grid item xs="auto">
              <Box className={classes.tabs}>
                <Box className={classes.tabsOver}>
                  <Box minWidth={!sm ? 776 : 670}>
                    <Tabs value={tab} onChange={handleChangeTab}>
                      <Tab label="1 этап" {...a11yProps(0)} />
                      <Tab label="2 этап" {...a11yProps(1)} />
                      {tourV3?.total > 0 && <Tab label="3 этап" {...a11yProps(2)} />}
                      {tourV4?.total > 0 && <Tab label="Финал" {...a11yProps(3)} />}
                    </Tabs>
                  </Box>
                </Box>
              </Box>
            </Grid>
          )}
          <Grid item xs={12}>
            <TabPanel value={tab} index={0}>
              {loaded && initTable && (
                <Grid container direction="row" alignItems="flex-start" justifyContent="center">
                  <Grid item xs={12}>
                    <form onSubmit={hookForm.handleSubmit(onSubmitForm)} autoComplete="off" noValidate>
                      <Box className={classes.form}>
                        <Grid
                          container
                          wrap="nowrap"
                          direction="row"
                          justifyContent={md ? 'center' : 'flex-start'}
                          alignItems="center"
                          spacing={sm ? 1 : 2}
                        >
                          <Grid container item xs="auto">
                            <Box width={sm ? 100 : 140} height={70}>
                              <SelectInput
                                label="Город"
                                names="region"
                                form={hookForm}
                                variant="outlined"
                                placeholder="Город"
                                items={dataFilter.region}
                                onSubmit={(event) => {
                                  getTourSubdivision(event.target.value).then((res) => {
                                    setDataFilter({ ...dataFilter, subdivision: res.data.subdivision })
                                  })
                                }}
                                menuItemNone={defaultItemSelect}
                                disabled={formProps.processed}
                              />
                            </Box>
                          </Grid>
                          <Grid container item xs="auto">
                            <Box width={sm ? 100 : 140} height={70}>
                              <SelectInput
                                variant="outlined"
                                names="subdivision"
                                label="Ресторан"
                                placeholder="Ресторан"
                                items={dataFilter.subdivision}
                                form={hookForm}
                                menuItemNone={defaultItemSelect}
                                disabled={formProps.processed}
                              />
                            </Box>
                          </Grid>
                          <Grid container item xs="auto">
                            <Box width={sm ? 100 : 140} height={70}>
                              <SelectInput
                                variant="outlined"
                                names="nomination"
                                label="Номинация"
                                placeholder="Номинация"
                                items={dataFilter.nomination}
                                form={hookForm}
                                menuItemNone={defaultItemSelect}
                                disabled={formProps.processed}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </form>
                  </Grid>
                </Grid>
              )}

              {loaded && tour && (
                <Grid
                  container
                  direction="row"
                  alignItems="flex-start"
                  justifyContent="center"
                  style={{ minHeight: 250 }}
                >
                  {tour.data?.length > 0 ? (
                    <Grid item xs={12}>
                      <TourList {...tour} stage={1} changePage={handleChange} />
                    </Grid>
                  ) : initTable ? (
                    <Box className={classes.text} textAlign="center">
                      Нет результатов поиска
                    </Box>
                  ) : (
                    <Box className={classes.text} textAlign="center">
                      Турнирная таблица появится после подтверждения первых заявок на участие в Кубке
                    </Box>
                  )}
                </Grid>
              )}
            </TabPanel>

            <TabPanel value={tab} index={1}>
              {loaded && initTableV2 && (
                <Grid container direction="row" alignItems="flex-start" justifyContent="center">
                  <Grid item xs={12}>
                    <form onSubmit={hookFormV2.handleSubmit(onSubmitFormV2)} autoComplete="off" noValidate>
                      <Box className={classes.form}>
                        <Grid
                          container
                          wrap="nowrap"
                          direction="row"
                          justifyContent={md ? 'center' : 'flex-start'}
                          alignItems="center"
                          spacing={sm ? 1 : 2}
                        >
                          <Grid container item xs="auto">
                            <Box width={sm ? 200 : 302} height={70}>
                              <SelectInput
                                variant="outlined"
                                names="tu"
                                label="Территориальный управляющий"
                                placeholder="Территориальный управляющий"
                                items={dataFilter.tu}
                                form={hookFormV2}
                                menuItemNone={defaultItemSelect}
                                disabled={formPropsV2.processed}
                              />
                            </Box>
                          </Grid>
                          <Grid container item xs="auto">
                            <Box width={sm ? 110 : 140} height={70}>
                              <SelectInput
                                variant="outlined"
                                names="nomination"
                                label="Номинация"
                                placeholder="Номинация"
                                items={dataFilter.nomination}
                                form={hookFormV2}
                                menuItemNone={defaultItemSelect}
                                disabled={formPropsV2.processed}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </form>
                  </Grid>
                </Grid>
              )}

              {loaded && tourV2 && (
                <Grid
                  container
                  direction="row"
                  alignItems="flex-start"
                  justifyContent="center"
                  style={{ minHeight: 250 }}
                >
                  {tourV2.data?.length > 0 ? (
                    <Grid item xs={12}>
                      <TourList {...tourV2} stage={2} changePage={handleChangeV2} />
                    </Grid>
                  ) : initTableV2 ? (
                    <Box className={classes.text} textAlign="center">
                      Нет результатов поиска
                    </Box>
                  ) : (
                    <Box className={classes.text} textAlign="center">
                      Ещё не стартовал второй этап
                    </Box>
                  )}
                </Grid>
              )}
            </TabPanel>

            <TabPanel value={tab} index={2}>
              {loaded && initTableV3 && (
                <Grid container direction="row" alignItems="flex-start" justifyContent="center">
                  <Grid item xs={12}>
                    <form onSubmit={hookFormV3.handleSubmit(onSubmitFormV3)} autoComplete="off" noValidate>
                      <Box className={classes.form}>
                        <Grid
                          container
                          wrap="nowrap"
                          direction="row"
                          justifyContent={md ? 'center' : 'flex-start'}
                          alignItems="center"
                          spacing={sm ? 1 : 2}
                        >
                          <Grid container item xs="auto">
                            <Box width={sm ? 200 : 302} height={70}>
                              <SelectInput
                                variant="outlined"
                                names="mm"
                                label="Маркет-менеджер"
                                placeholder="Маркет-менеджер"
                                items={dataFilter.mm}
                                form={hookFormV3}
                                menuItemNone={defaultItemSelect}
                                disabled={formPropsV3.processed}
                              />
                            </Box>
                          </Grid>
                          <Grid container item xs="auto">
                            <Box width={sm ? 110 : 140} height={70}>
                              <SelectInput
                                variant="outlined"
                                names="nomination"
                                label="Номинация"
                                placeholder="Номинация"
                                items={dataFilter.nomination}
                                form={hookFormV3}
                                menuItemNone={defaultItemSelect}
                                disabled={formPropsV3.processed}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </form>
                  </Grid>
                </Grid>
              )}

              {loaded && tourV3 && (
                <Grid
                  container
                  direction="row"
                  alignItems="flex-start"
                  justifyContent="center"
                  style={{ minHeight: 250 }}
                >
                  {tourV3.data?.length > 0 ? (
                    <Grid item xs={12}>
                      <TourList {...tourV3} stage={3} changePage={handleChangeV3} />
                    </Grid>
                  ) : initTableV3 ? (
                    <Box className={classes.text} textAlign="center">
                      Нет результатов поиска
                    </Box>
                  ) : (
                    <Box className={classes.text} textAlign="center">
                      Ещё не стартовал третий этап
                    </Box>
                  )}
                </Grid>
              )}
            </TabPanel>

            <TabPanel value={tab} index={3}>
              {loaded && initTableV4 && (
                <Grid container direction="row" alignItems="flex-start" justifyContent="center">
                  <Grid item xs={12}>
                    <form onSubmit={hookFormV4.handleSubmit(onSubmitFormV4)} autoComplete="off" noValidate>
                      <Box className={classes.form}>
                        <Grid
                          container
                          wrap="nowrap"
                          direction="row"
                          justifyContent={md ? 'center' : 'flex-start'}
                          alignItems="center"
                          spacing={sm ? 1 : 2}
                        >
                          <Grid container item xs="auto">
                            <Box width={sm ? 110 : 140} height={70}>
                              <SelectInput
                                variant="outlined"
                                names="nomination"
                                label="Номинация"
                                placeholder="Номинация"
                                items={dataFilter.nomination}
                                form={hookFormV4}
                                menuItemNone={defaultItemSelect}
                                disabled={formPropsV4.processed}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </form>
                  </Grid>
                </Grid>
              )}

              {loaded && tourV4 && (
                <Grid
                  container
                  direction="row"
                  alignItems="flex-start"
                  justifyContent="center"
                  style={{ minHeight: 250 }}
                >
                  {tourV4.data?.length > 0 ? (
                    <Grid item xs={12}>
                      <TourList {...tourV4} stage={4} changePage={handleChangeV4} />
                    </Grid>
                  ) : initTableV4 ? (
                    <Box className={classes.text} textAlign="center">
                      Нет результатов поиска
                    </Box>
                  ) : (
                    <Box className={classes.text} textAlign="center">
                      Ещё не стартовал финал
                    </Box>
                  )}
                </Grid>
              )}
            </TabPanel>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  page: {
    width: '100%',
    padding: '100px 0 70px',
    backgroundColor: '#141414',
    overflow: 'hidden',
    minHeight: 250,
    [down('lg')]: {
      padding: '80px 0 60px',
    },
    [down('sm')]: {
      padding: '50px 0 50px',
    },
  },
  container: {
    maxWidth: '1100px!important',
    [down('sm')]: {
      padding: '0 10px!important',
    },
  },
  title: {
    fontSize: 48,
    fontWeight: 700,
    textAlign: 'center',
    color: palette.error.main,
    textTransform: 'uppercase',
    marginBottom: 40,
    [down('lg')]: {
      fontSize: 44,
      marginBottom: 30,
    },
    [down('sm')]: {
      fontSize: 32,
      marginBottom: 20,
    },
  },
  form: {
    '& .MuiFormHelperText-root': {
      fontSize: 10,
      marginLeft: 10,
      [down('sm')]: {
        fontSize: 8,
      },
    },
    '& .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root svg': {
      width: 5,
      height: 5,
    },
  },
  text: {
    fontWeight: 500,
    fontSize: 20,
    marginTop: '13vh',
    lineHeight: 1.4,
    [down('md')]: {
      fontSize: 17,
    },
    [down('sm')]: {
      marginTop: '10vh',
      fontSize: 14,
    },
  },
  tabs: {
    width: '100vw',
    maxWidth: 776,
    [down('md')]: {
      overflow: 'hidden',
    },
  },
  tabsOver: {
    width: '100%',
    [down('md')]: {
      overflowX: 'auto',
    },
  },
}))
